export default __webpack_public_path__ + "static/media/tik-tok.da20ff5f.svg";